export const messages = {
  configurePageTitle: 'Configure Sweepstakes',
  updatePageTitle: 'Update Sweepstakes',
  subtitle: 'Reduce point liability and drive product purchases through a sweepstakes',
};
